"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import SectionHeading from "@/components/explore-sections/shared/heading";
import ProductGrid from "./product/listing/ProductGrid";
import { getCollectionById } from "@/services/api/collections";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { QUICK_PICKS_PRODUCT_TYPE_ID } from "@/constants/product";
import { sendGAEvent } from "@next/third-parties/google";
import Skeleton from "@/components/ui/skeleton";
import SectionHeadingLoader from "@/components/explore-sections/shared/heading/loader";
interface QuickPickProduct {
  id?: string;
  product_urls?: string[];
  name?: string;
  product_subtype_details?: {
    name?: string;
  };
  category?: string;
  base_price_amount?: string | number;
  [key: string]: unknown;
}
function modifyCollectionProductsResponse(data: QuickPickProduct[] | undefined | null) {
  return data?.map((product: QuickPickProduct) => {
    return {
      id: product?.id || "",
      image: product?.product_urls?.[0] || "",
      title: product?.name || "",
      subtitle: product?.product_subtype_details?.name || product?.category || "",
      price: parseFloat(product?.base_price_amount || 0),
      rating: 0,
      totalUsers: 0,
      // tags: tags.slice(0, 3), // Limit to 3 tags to avoid UI overflow
      tags: [],
      baker: product?.vendor_details?.business_name || "",
      type: product?.dietary_type === "NON_VEG" ? "non-veg" : product?.dietary_type === "VEG" ? "veg" : "",
      product_subtype: product?.product_subtype_id,
      product_type: product?.product_type_id,
      slug: product?.slug || "",
      vendorSlug: product?.vendor_details?.slug || "",
      vendorId: product?.vendor_details?.id || "",
      // Add additional fields that might be useful
      discount: product?.discount_percentage || null,
      bestSeller: product?.is_best_product || false,
      banner: product?.vendor_discount_text || null,
      product_type_name: product?.product_type_name || "",
      product_subtype_name: product?.product_subtype_details?.name || ""
    };
  });
}
const QuickPicksSkeleton: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SectionHeadingLoader />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="max-w-[1440px] mx-auto lg:px-12 px-2 mt-[2rem] lg:mt-[3rem] bg-v2-surface pt-[2rem] lg:pt-[3rem]">{t0}<div className="lg:px-2 w-full mt-[2rem] lg:pb-[3rem] pb-[2rem]"><div className="bg-v2-surface lg:p-4 max-lg:px-2 rounded-lg"><div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 lg:gap-4 gap-2">{Array.from({
              length: 6
            }).map(_temp)}</div></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const QuickPicksCakes: React.FC = () => {
  const $ = _c(18);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["collection", QUICK_PICKS_PRODUCT_TYPE_ID.toString()],
      queryFn: _temp2,
      staleTime: Infinity,
      select: _temp3,
      gcTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: collection,
    isLoading
  } = useQuery(t0);
  if (isLoading) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <QuickPicksSkeleton />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (!collection || !collection.slug || !collection.id) {
    return null;
  }
  const t1 = collection.title || "";
  const t2 = collection.description || "";
  const t3 = `/listing/${collection.slug}?id=${collection.id}`;
  let t4;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = <SectionHeading heading={t1} subHeading={t2} link={t3} onClick={_temp4} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = collection?.products;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    t7 = [];
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== collection.id || $[9] !== collection.slug || $[10] !== router) {
    t8 = () => {
      sendGAEvent("event", "show_more_quick_picks_clicked");
      router.push(`/listing/${collection.slug}?id=${collection.id}`);
    };
    $[8] = collection.id;
    $[9] = collection.slug;
    $[10] = router;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <ProductGrid quickPicksSection={true} products={t5} buttonActive={true} categories={t6} selectedcategories={t7} handleCategoryChange={_temp5} buttonClickFunction={t8} />;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t9) {
    t10 = <div className="max-w-[1440px] mx-auto lg:px-12 px-2 mt-[2rem] lg:mt-[3rem] bg-v2-surface pt-[2rem] lg:pt-[3rem]">{t4}{t9}</div>;
    $[15] = t4;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default QuickPicksCakes;
function _temp(_, index) {
  return <div key={index} className="bg-white rounded-lg overflow-hidden p-2 flex max-sm:flex-col w-full"><div className="max-sm:w-full w-1/2 max-sm:h-32 max-sm:mb-2 lg:h-48 rounded-lg overflow-hidden relative flex-shrink-0"><Skeleton className="w-full h-full" rounded="lg" /></div><div className="max-sm:w-full w-1/2 max-sm:px-0 lg:px-4 max-sm:py-0 md:h-40 lg:h-48 max-h-28 flex flex-col justify-between items-start space-y-3"><div className="w-full space-y-2"><Skeleton className="h-5 w-3/4" /><Skeleton className="h-4 w-1/2" /></div><div className="w-full space-y-2 pt-4"><Skeleton className="h-4 w-1/3" /><Skeleton className="h-4 w-2/3" /></div></div></div>;
}
function _temp2() {
  return getCollectionById(QUICK_PICKS_PRODUCT_TYPE_ID.toString());
}
function _temp3(data) {
  return {
    products: modifyCollectionProductsResponse(data?.products?.results || []),
    title: data?.name,
    description: data?.metadata?.description || "",
    slug: data?.slug,
    id: data?.id
  };
}
function _temp4() {
  return sendGAEvent("event", "show_more_quick_picks_clicked");
}
function _temp5() {}